module.exports = __webpack_public_path__ + "static/media/213.2e9f294e.png";